/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "FailAsyncTransactionRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "options": {
                    "type": ".squareup.esperanto.common.ReverseOptions",
                    "id": 3,
                    "rule": "optional"
                  },
                  "multiBrandTransactionDetails": {
                    "type": ".squareup.esperanto.common.AsyncMultiBrandTransactionDetails",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FailAsyncTransactionResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.esperanto.api.FailAsyncTransactionResponse.FailAsyncTransactionError",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "FailAsyncTransactionError": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INVALID_STATE": 1,
                      "RECORD_NOT_FOUND": 2,
                      "INVALID_TRANSACTION_TYPE": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FailAsyncTransactionRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FailAsyncTransactionResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.FailAsyncTransactionResponse?.nested?.FailAsyncTransactionError) {
  $root.addJSON(jsonData);
}

/**
 * Request payload for failing a submitted async transaction.
 *
 * SOURCE FailAsyncTransactionRequest @ squareup/esperanto/api/fail_async_transaction.proto at 14:1
 */
export const FailAsyncTransactionRequest = $root.lookupType('squareup.esperanto.api.FailAsyncTransactionRequest');
fixType(FailAsyncTransactionRequest, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(FailAsyncTransactionRequest);
/**
 * Response payload for failing a submitted async transaction.
 * The resulting AsyncTransactionStatus status should be FAILED.
 *
 * SOURCE FailAsyncTransactionResponse @ squareup/esperanto/api/fail_async_transaction.proto at 31:1
 */
export const FailAsyncTransactionResponse = $root.lookupType('squareup.esperanto.api.FailAsyncTransactionResponse');
fixType(FailAsyncTransactionResponse, {
  paymentId: {
    required: true
  }
});
Builder.createAndAttachToType(FailAsyncTransactionResponse);
/**
 * Error types for FailAsyncTransaction
 *
 * SOURCE FailAsyncTransactionError @ squareup/esperanto/api/fail_async_transaction.proto at 37:3
 */
FailAsyncTransactionResponse.FailAsyncTransactionError = $root.lookupEnum('squareup.esperanto.api.FailAsyncTransactionResponse.FailAsyncTransactionError').values;